module.exports = __webpack_public_path__ + "static/media/PESV_MENU-normal.323c4046.png";